export default "__VITE_ASSET__CnD3vdEN__"